import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { Client } from "../../../core/api-client/api-client";
import { API_DASHBOARD_EMBED_URL, API_DASHBOARD_LIST } from "../../../core/route/api.routes";
import { Skeleton } from "antd";

function ReportComponent(props: any){
    const [embedConfig, setEmbedConfig] = useState(null as any);
    const [loading, setLoading] = useState(false as any);
    useEffect(()=>{
        getDashboardEmbedUrl()
    }, [])
    const getDashboardEmbedUrl = async () => {
        if(props?.dashboard){
            setLoading(true)
            setEmbedConfig(null)
            const data =  await Client.get(API_DASHBOARD_EMBED_URL, {params: {dashboard: props?.dashboard}});
            console.log(data)
            if(data?.data?.data?.embedToken && data?.data?.data?.reportsDetail){
                setEmbedConfig({
                    type: 'report',   // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                    id: data?.data?.data?.reportsDetail[0]?.reportId,
                    embedUrl: data?.data?.data?.reportsDetail[0]?.embedUrl,
                    accessToken: data?.data?.data?.embedToken?.token,
                    tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
                    settings: {
                        panes: {
                            filters: {
                                expanded: false,
                                visible: true
                            }
                        },
                        //background: models.BackgroundType.Transparent,
                    }
                })
                setLoading(false)
            }
        }
        
    }
    console.log(embedConfig)
    return <>
        {embedConfig?.embedUrl && !loading && <PowerBIEmbed 
            embedConfig= {embedConfig}
            eventHandlers={
                new Map([
                    ['loaded', function () {console.log('Report loaded');}],
                    ['rendered', function () {console.log('Report rendered');}],
                    ['error', function (event:any) {console.log(event.detail);}],
                    ['visualClicked', () => console.log('visual clicked')],
                    ['pageChanged', (event:any) => console.log(event)],
                ])
            }
            cssClassName={"reportClass"}
            getEmbeddedComponent = { (embeddedReport) => {
                // report = embeddedReport as Report;
            }}
        
        />}
        {loading ? <Skeleton /> : <></>}
    </>
}

export default ReportComponent;